// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import {api, utils} from './helpers/'
import axios from 'axios'
import Buefy from 'buefy'
import TableComponent from 'vue-table-component'
import {cacheAdapterEnhancer} from 'axios-extensions'

/**
 * Table component dependency
 */

TableComponent.settings({
  tableClass: 'table is-bordered is-striped is-hoverable is-fullwidth',
  filterPlaceholder: 'Cerca...',
  filterNoResults: 'Nessun risultato',
  showCaption: false,
  filterInputClass: 'input'
})
Vue.use(TableComponent)

/**
 * Buefy dependency
 */

Vue.use(Buefy, {defaultIconPack: 'fas'})

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// let token = document.head.querySelector('meta[name="csrf-token"]')
// if (!token) {
//   console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
// }
window.http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    common: {
      'Authorization': store.state.auth.token ? `Bearer ${store.state.auth.token}` : '',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache',
      'X-Requested-With': 'XMLHttpRequest'
      // 'X-CSRF-TOKEN': token.content || ''
    }
  },
  // `timeout` specifies the number of milliseconds before the request times out.
  // If the request takes longer than `timeout`, the request will be aborted.
  timeout: 30000,
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
    enabledByDefault: false
  })
})

Vue.config.productionTip = false

/**
 * Check for user current status on document visibility change and on online status change, so
 * the user can — or not — send a status.
 */

let checkIfOffline = () => {
  utils.isOnline().then(response => {
    window.document.querySelector('body').style = response ? '' : 'filter: grayscale(1)'
  })
}

// Connection status change
window.addEventListener('offline', checkIfOffline)
window.addEventListener('online', checkIfOffline)

// Visibility change
document.addEventListener('visibilitychange', () => checkIfOffline() && api.check())

// Check if is online
checkIfOffline()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js